import { Popup } from 'components';
import MandateSidePanel from 'containers/Mandate/MandateSidePanel';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const MandateActions = ({ data, resetMandateTransactionList }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);

    const handleOpenActionPopup = actionType => {
        resetMandateTransactionList();
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = () => {
        setShowFilter(false);
        setActionType(null);
    };

    return (
        <div className="userAction  multiItem">
            <button className="view" onClick={handleOpenActionPopup} />
            <Popup
                title="MANDATE DETAILS"
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={data.original}
                closePopup={handleCloseOpenActionPopup}
                type="MEDIUM"
            >
                <MandateSidePanel data={data.original} />
            </Popup>
        </div>
    );
};

MandateActions.propTypes = {
    data: PropTypes.object,
};

export default MandateActions;
